<div id="templateViewWrapper" class="containerWrapper">
  <mat-progress-bar mode="indeterminate" *ngIf="showTemplatesProgress"></mat-progress-bar>
  <div [class]="builderService.loadingTemplates ? 'overlayBG' : 'hide'">
    <div class="overlayContent">
      <img _ngcontent-olv-c289="" src="assets/images/paint-roller.gif" />
      {{ 'Applying Template' | translate }}
    </div>
  </div>
  <div id="titleContainer">
    <h1>{{ 'Choose Website Template' | googleTranslate | async | extractGoogleTranslation }}</h1>
    <div class="howItWorks noselect" (click)="howItWorksDialog()">
      <span class="material-icons-outlined">play_circle_filled</span>
      {{ 'How it works?' | googleTranslate | async | extractGoogleTranslation }}
    </div>
  </div>

  <ul id="templatesList">
    <li *ngFor="let template of templatesList" (click)="selectNewTemplate(template)">
      <div class="templateImg"><img src="{{ template.img }}" alt="{{ template.name }}" /></div>
      <p>{{ template.name | googleTranslate | async | extractGoogleTranslation }}</p>
      <div class="caption-separator"></div>
    </li>
  </ul>

  <div *ngIf="templatesList.length === 0 && !showTemplatesProgress" class="noTemplates">
    <p>{{ 'No website templates available yet.' | translate }}</p>
    <p>{{ 'Create a template from your current website pages to get started.' | translate }}</p>
  </div>
</div>

<app-template-apply-dialog
  [isOpen]="applyDialogOpen"
  [templateName]="applyDialogTemplate?.name || ''"
  (closed)="onApplyDialogClosed()"
  (confirmed)="onApplyDialogConfirmed()"
></app-template-apply-dialog>
